import { map } from "nanostores";

const userProfile = map({
  loading: true,
  auth: undefined,
  data: {},
  documents: {
    ownerData: [],
    signersData: [],
    counts: {
      pendingSignature: 0,
      pendingYourSignature: 0,
      signedCard: 0,
      pendingInsights: 0,
    },
  },
});

const setUserData = (data) => {
  userProfile.setKey("data", data);
};

const setDocuments = (documents) => {
  userProfile.setKey("documents", documents);
  userProfile.setKey("loading", false);
};

const setIsAuthenticated = (auth) => {
  userProfile.setKey("auth", auth);
  if (!auth) {
    userProfile.setKey("loading", false);
  }
};

const setLoading = (loading) => {
  userProfile.setKey("loading", loading);
};

export { userProfile, setUserData, setIsAuthenticated, setLoading, setDocuments };
